import { render, staticRenderFns } from "./TeamsDeliveryMode.vue?vue&type=template&id=36a37687&scoped=true"
import script from "./TeamsDeliveryMode.vue?vue&type=script&lang=js"
export * from "./TeamsDeliveryMode.vue?vue&type=script&lang=js"
import style0 from "./TeamsDeliveryMode.vue?vue&type=style&index=0&id=36a37687&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a37687",
  null
  
)

export default component.exports